import React, { useState, useEffect } from "react";
import "./LoaderScreen.scss";
import personCalling from "../../../assets/images/solar_phone-linear.png";
import { flask_url, socket } from "./../../../Socket";
import { formatSecondsToTime } from "../../../helper";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";

const LoaderScreen = ({ agentData, getLoader, customerData, customer_numbers, hideLoader, setHideLoader, runnigDialer, setRunningDialer }) => {
  const [currentPageOldLogs, setCurrentPageOldLogs] = useState(1);
  const itemsPerPageOldLogs = 10;
  // Calculate the index range for the current page
  const startIndexOldLogs = (currentPageOldLogs - 1) * itemsPerPageOldLogs;
  const endIndexOldLogs = startIndexOldLogs + itemsPerPageOldLogs;
  const [userLogs, setUserLogs] = useState([]);

  // const [runnigDialer, setRunningDialer] = useState(false);
  // const [hideLoader, setHideLoader] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [calls, setCalls] = useState([]);

  // ----------------------------------------------------------------------------------------------------------------------------------------

  const [remaningCalls, setRemaningCalls] = useState([]);
  const [dialedCalls, setDialedCalls] = useState([]);

  const [remaningCallHubspot, setRemaningCallHubspot] = useState([]);
  const [dialedCallHubspot, setDialedCallHubspot] = useState([]);

  // useEffect(() => {
  //   const newSocket = new WebSocket("wss://gpd-production.onrender.com/ws");

  //   newSocket.onopen = (event) => {
  //     console.log("WebSocket connection opened:", event);
  //   };

  //   newSocket.onmessage = async (event) => {
  //     let data = await JSON.parse(event.data);

  //     if (data.event === "manual_dialer_csv_stats") {
  //       console.log("manual_dialer_csv_stats", data);

  //       setRemaningCalls(data?.data?.CustomersRemaining);
  //       setDialedCalls(data?.data?.CustomersCalled);
  //     }
  //   };

  //   return () => {
  //     newSocket.close();
  //   };
  // }, []);

  // useEffect(() => {
  //   const newSocket = new WebSocket("wss://gpd-production.onrender.com/ws");

  //   newSocket.onopen = (event) => {
  //     console.log("WebSocket connection opened:", event);
  //   };

  //   newSocket.onmessage = async (event) => {
  //     let data = await JSON.parse(event.data);

  //     if (data.event === "manual_dialer_hubspot_stats") {
  //       console.log("manual_dialer_hubspot_stats ------------------------------------------>", data);

  //       setRemaningCallHubspot(data?.data?.CustomersRemaining);
  //       setDialedCallHubspot(data?.data?.CustomersCalled);
  //     }
  //   };

  //   return () => {
  //     newSocket.close();
  //   };
  // }, []);

  // console.log("remaningCalls", remaningCalls);
  // console.log("dialedCalls", dialedCalls);

  var userId = JSON.parse(localStorage.getItem("userId"));

  useEffect(() => {
    const newSocket = new WebSocket("wss://gpd-production.onrender.com/ws");

    newSocket.onopen = (event) => {
      console.log("WebSocket connection opened:", event);
      const initialMessage = "Hello, WebSocket!";
      newSocket.send(initialMessage);
    };

    newSocket.onmessage = async (event) => {
      let data = await JSON.parse(event.data);

      if (data.event === "manual_dialer_csv") {
        console.log("manual_dialer_csv", data);
        const res = data?.data;
        if (res) {
          var filteredData = res.filter((item) => item.user_id === userId);
        }
      }

      setCalls(filteredData);
    };

    return () => {
      newSocket.close();
    };
  }, []);

  // console.log("Socket Calls Data :", calls);
  // console.log("Loder Screen Agent Numbers :", agentData);
  // console.log("Loder Screen Customer Numbers :", customerData);

  // console.log("User ID Dikha", userId);
  const handleCallConnecting = () => {
    const userId = JSON.parse(localStorage.getItem("userId"));

    if (!userId) {
      toast.error("User Id Required");
      return;
    }

    if (customerData) {
      // StartDialer({
      //   agent_data: agentData,
      //   customers: customerData || [],
      //   dialer_type: 'csv',
      //   agent_id: userId,
      //   // user_id: userId,
      // });
      StartDialer({
        customers: customerData || [],
        dialer_type: 'csv',
        agent_id: '65d5ad97a8e4f921a5a93c6c',
        // user_id: userId,
      });
    } else {
      alert("Upload File First");
    }
  };

  const StartDialer = async (data) => {
    // try {
    //   console.log("data inside dialer :", data);
    //   const requestOptions = {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(data),
    //   };
    //   // fetch(`${flask_url}/start-dialing`, requestOptions)
    //   fetch(`${flask_url}/outboundcall_agentdialer`, requestOptions)
    //     .then((response) => {response.json();console.log("Reponse dikha", response.json);})
    //     .catch((error) => {
    //       console.error("Error during POST request:", error);
    //     });
    // } catch (error) {
    //   console.log(error);
    // }

    try {
      console.log("data inside dialer :", data);

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://gpd-production.onrender.com/outboundcall_agentdialer',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
      };


      // const requestOptions = {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },

      // };
      // fetch(`${flask_url}/start-dialing`, requestOptions)

      axios(config)
        .then((response) => { console.log("Reponse dikha axios ka", response.data); })
        .catch((error) => {
          console.error("Error during POST request:", error);
        });

      //   fetch(`${flask_url}/outboundcall_agentdialer`, requestOptions)
      //     .then((response) => {response.json();console.log("Reponse dikha", response.json);})
      //     .catch((error) => {
      //       console.error("Error during POST request:", error);
      //     });
    } catch (error) {
      console.log(error);
    }
  };

  const handleRunningDialer = () => {
    // setRunningDialer(true);
    setHideLoader(false);
  };

  const TerminateDialer = async () => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId }),
      };
      const response = await fetch(`${flask_url}/TerminateCompaign`, requestOptions);

      const responseData = await response.json();
      toast.success("Dialer Terminated");
      console.log("Terminate successful:", responseData);
    } catch (error) {
      toast.error("Somethind went wrong");
      console.error("Error during TerminateDialer:", error);
    }
  };

  const TerminateCall = async (call) => {
    console.log("Call :", call);
    var call_sid = call["call_sid"];

    console.log("call Sid :", call_sid);

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ call_sid }),
      };

      const response = await fetch(`${flask_url}/terminate-this-call`, requestOptions);

      const responseData = await response.json();
      console.log("Terminate successful:", responseData);
    } catch (error) {
      console.error("Error during Terminate Dialer:", error);
    }
  };

  const [shows, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [DialerTabs, setDialerTabs] = useState("currentdialer");

  const handleDialerTabs = (tab) => {
    setDialerTabs(tab);
  };
  return (
    <>
      {/* {showLoader && (
        <div className="loaderWrapper">
          <div className="loaderMain">
            <div className="loader"></div>
            <h5 className="mt-3">File is uploading...</h5>
          </div>
        </div>
      )} */}
      {/* {hideLoader && (
        <div className="call-agent">
          <h2 className="mb-3">Your file has been uploaded successfully </h2>
          <h2 className="mb-3">Click on start button to start dialing </h2>
          <button
            className="dialBtn"
            onClick={() => {
              handleCallConnecting();
              handleRunningDialer();
            }}
          >
            Start Dialing sss
          </button>
        </div>
      )} */}
      {runnigDialer && (
        <div className="AgentScreenWrapper">
          <div className="top-div d-flex justify-content-between">
            <h2>Running Dialer</h2>
            <button className="theme-1" onClick={TerminateDialer}>
              Terminate
            </button>
          </div>

          {/* Dialer Tabs */}
          <div className="DialerTabs d-flex justify-content-end gap-4 pt-2 pr-4">
            <button className="themebtn-1" onClick={() => handleDialerTabs("currentdialer")}>
              Current Dialer
            </button>
            <button className="themebtn-1" onClick={() => handleDialerTabs("inqueue")}>
              In Queue
            </button>
            <button className="themebtn-1" onClick={() => handleDialerTabs("dialed")}>
              Dialed
            </button>
          </div>
          {/* Dialer Tabs */}
          {DialerTabs === "currentdialer" && (
            <div className="agentGrid">
              {calls && calls.length !== 0 ? (
                calls
                  .slice()
                  .reverse()
                  .map((item) => {
                    return (
                      <>
                        <div className="dialer-callingOption-box">
                          <img src={personCalling} className="runningDialer-Calling-Img" alt="" />
                          <h6>
                            Agent Name : <span> {item?.agent_name} </span>
                          </h6>
                          <h6>
                            Agent Number: <span> {item?.agent_number} </span>
                          </h6>
                          <h6>
                            Client Name: <span> {item?.CustomerName} </span>
                          </h6>
                          <h6>
                            Service Type: <span> {item?.ServiceType} </span>
                          </h6>
                          <h6>
                            Client Number: <span> {item?.PhoneNumber} </span>
                          </h6>

                          <p className="statusCall">
                            Status: <span> {item.call_status}</span>
                          </p>
                          <p className="statusCall">
                            Duration: <span> {formatSecondsToTime(item?.call_duration)}</span>
                          </p>
                          {item?.call_status === "queued" ||
                          item?.call_status === "initiated" ||
                          item?.call_status === "ringing" ||
                          item?.call_status === "answered" ||
                          item?.call_status === "in-progress" ||
                          item?.call_status === "Connected to Agent" ||
                          item?.call_status === "Connecting to Agent" ||
                          item?.call_status === "Ringing to Agent" ? (
                            <button
                              onClick={() => {
                                TerminateCall(item);
                              }}
                              className="termBtn mt-3"
                            >
                              Terminate
                            </button>
                          ) : (
                            <></>
                          )}
                        </div>
                      </>
                    )
                  })
              ) : (
                <></>
              )}
            </div>
          )}
          {DialerTabs === "inqueue" && (
            <>
              <table className="contact-table">
                <thead>
                  <tr>
                    <th>Customer Name</th>
                    <th>Service Type</th>
                    <th>Customer Phone Number</th>
                    <th>Agent Phone Number</th>
                  </tr>
                </thead>
                <tbody>
                  {remaningCalls && remaningCalls.length != 0 ? (
                    remaningCalls.map((item) => (
                      <tr>
                        <td>{item.CustomerName}</td>
                        <td>{item.ServiceType}</td>
                        <td>{item.PhoneNumber}</td>
                        <td>{item.CompanyName}</td>
                      </tr>
                    ))
                  ) : (
                    <></>
                  )}
                  {remaningCallHubspot && remaningCallHubspot.length != 0 ? (
                    remaningCallHubspot.map((item) => (
                      <tr>
                        <td>{item.CustomerName}</td>
                        <td>{item.ServiceType}</td>
                        <td>{item.PhoneNumber}</td>
                        <td>{item.CompanyName}</td>
                      </tr>
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
              <div className="pagination-container">
                <button className="themebtn-1" onClick={() => setCurrentPageOldLogs((prevPage) => Math.max(prevPage - 1, 1))} disabled={currentPageOldLogs === 1}>
                  Previous
                </button>
                <span>{currentPageOldLogs}</span>
                <button
                  className="themebtn-1"
                  onClick={() => setCurrentPageOldLogs((prevPage) => Math.min(prevPage + 1, Math.ceil(userLogs.length / itemsPerPageOldLogs)))}
                  disabled={currentPageOldLogs === Math.ceil(userLogs.length / itemsPerPageOldLogs)}
                >
                  Next
                </button>
              </div>
            </>
          )}
          {DialerTabs === "dialed" && (
            <>
              <table className="contact-table">
                <thead>
                  <tr>
                    <th>Customer Name</th>
                    <th>Service Type</th>
                    <th>Customer Phone Number</th>
                    <th>Company Name</th>
                  </tr>
                </thead>
                <tbody>
                  {dialedCalls && dialedCalls.length != 0 ? (
                    dialedCalls.map((item) => (
                      <tr>
                        <td>{item.CustomerName}</td>
                        <td>{item.ServiceType}</td>
                        <td>{item.PhoneNumber}</td>
                        <td>{item.CompanyName}</td>
                      </tr>
                    ))
                  ) : (
                    <></>
                  )}
                  {dialedCallHubspot && dialedCalls.length != 0 ? (
                    dialedCalls.map((item) => (
                      <tr>
                        <td>{item.CustomerName}</td>
                        <td>{item.ServiceType}</td>
                        <td>{item.PhoneNumber}</td>
                        <td>{item.CompanyName}</td>
                      </tr>
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
              <div className="pagination-container">
                <button className="themebtn-1" onClick={() => setCurrentPageOldLogs((prevPage) => Math.max(prevPage - 1, 1))} disabled={currentPageOldLogs === 1}>
                  Previous
                </button>
                <span>{currentPageOldLogs}</span>
                <button
                  className="themebtn-1"
                  onClick={() => setCurrentPageOldLogs((prevPage) => Math.min(prevPage + 1, Math.ceil(userLogs.length / itemsPerPageOldLogs)))}
                  disabled={currentPageOldLogs === Math.ceil(userLogs.length / itemsPerPageOldLogs)}
                >
                  Next
                </button>
              </div>
            </>
          )}
          {/* Dialer Tabs */}

          <Modal show={shows} onHide={handleClose} className="agentModal">
            <Modal.Header closeButton>
              <Modal.Title className="titleOfModal">Customer Response Type</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modalBody">
              <div className="choosingCase">
                <p>Concrete Restoration</p>
              </div>
              <div className="choosingCase">
                <p>Stucco Repair</p>
              </div>
              <div className="choosingCase">
                <p>Painting</p>
              </div>
            </Modal.Body>
            {/* <Modal.Footer>
            <Button className="save-btn">Save</Button> 
            </Modal.Footer> */}
          </Modal>

          {/* <button className="" onClick={handleShow}>ssasdas</button> */}
        </div>
      )}
    </>
  );
};
export default React.memo(LoaderScreen);
